import React, { useState } from "react";
import "@Styles/mandate.css";
import Heading from "../Common/MainHeading";
import { HEADING_ESIGN } from "../Common/constant";
import { Modal } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { Form } from "semantic-ui-react";

const ESign = (props) => {
  const [show, setShow] = useState(false);
  const [isshow, setIsShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const otpClose = () => setIsShow(false);
  const otpShow = () => setIsShow(true);
  return (
    <div className="main_div">
      <div className="container">
        <div className="pb-4">
          <div className="esign_heading flex space-between align-center">
            <Heading
              headingText={HEADING_ESIGN}
              backprops={"/DummyDashboard"}
              history={props.history}
            />
            <span onClick={handleShow}>?</span>
          </div>
          <div className="wrapper-content e-sign">
            <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-4 pb-5">
                  <p className="text-left">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p className="text-left">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p className="text-left">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p className="text-left">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p className="text-left">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="checkbox">
          <label className="main-check">
            I have read the above and agree to the terms
            <input type="checkbox" id="check" required />
            <span className="geekmark"></span>
          </label>
        </div>
        <div className="text-center pt-4">
          <button
            className="btn bg-orange text-white rounded-pill px-5 py-3 mb-3"
            onClick={otpShow}
          >
            Sign with OTP
          </button>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} className="modal_flex">
        <Modal.Body>
          <div className="popup-div">
            <span className="heading-pop">What is E-sign?</span>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
          <div className="button-wrapper text-center">
            <a
              className="btn bg-white text-white rounded-pill bg-whitee"
              onClick={handleClose}
            >
              Okay
            </a>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={isshow} onHide={otpClose} className="modal_flex">
        <Modal.Body>
          <div className="popup-div">
            <span className="heading-pop">Enter OTP</span>
            <Form>
              <Form.Field>
                <div>
                  <OtpInput
                    containerStyle="otpCover"
                    numInputs={4}
                    inputType="number"
                    renderSeparator={<span></span>}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>
              </Form.Field>
            </Form>
          </div>
          <div className="button-wrapper text-center">
            <a
              className="btn bg-orange text-white rounded-pill"
              onClick={otpClose}
            >
              Confirm
            </a>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ESign;
